import { createCoreMethod } from '../../utils/createCoreMethod';

export const saveToLocalStorage = createCoreMethod(
  'saveToLocalStorage',
  async (key: string, value: string) => {
    await figma.clientStorage.setAsync(key, value);
  }
);
